import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
  border: 2px solid #c9c9c9;
  flex-direction: row;
  @media (max-width: 324px){
    flex-direction: column;
    justify-content: center;
  }
`;

export const Legend = styled.div`
  font-size: 14px;
  color: #7f7f7f;
  margin-right: 6px;
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 12px;
  font-weight: 300;
`;

export const Left = styled.div`
  margin-left: 10px;
  display:flex;
  flex-direction: column;
`

export const Middle = styled.div`
  display:flex;
  flex-direction: column;
  @media (max-width: 324px){
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
`

export const Right = styled.div`
  display:flex;
  flex-direction: column;
  @media (max-width: 324px){
    align-items: flex-end;
  }
`

export const Details = styled.div`
  padding: 0px 10px;
  width: 90px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000FFF;
  color: #FFF;
  font-size: 12px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
`

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5
}
